import EditableQuestion from '~/components/forms/EditableQuestion';
import SortableContainers from '~/components/SortableContainers';
import React, { memo, useCallback, useState } from 'react';
import Section from '~/components/forms/Section';

const Item = memo(({ item, onClick }) => {
    console.log('Re-rendering', item);
    return <div onClick={onClick}>Item = {item.label}</div>;
});

const TestPage = ({}) => {
    const [sortableItems, setSortableItems] = useState({
        1: [
            { id: 1, label: 'item one' },
            { id: 2, label: 'item two' },
            { id: 3, label: 'item three' },
        ],
        2: [
            { id: 4, label: 'another one' },
            { id: 5, label: 'another two' },
        ],
    });

    const onReorder = useCallback(newItems => {
        console.log('reorder = ', newItems);
    }, []);

    const renderContainer = useCallback(({ listId, idx, children }) => {
        return (
            <div>
                <h2>Container for {idx}</h2>
                {children}
            </div>
        );
    }, []);

    const clicked = useCallback(() => {
        setSortableItems(old => ({
            ...old,
            2: [...old[2], { id: Math.random(), label: 'Plus plus' }],
        }));
    }, []);

    const renderItem = useCallback(
        ({ item, isActive }) => <Item item={item} onClick={clicked} />,
        [],
    );

    return (
        <div>
            <h1>Test</h1>
            <SortableContainers
                items={sortableItems}
                setItems={onReorder}
                renderItem={renderItem}
                Container={renderContainer}
            />
        </div>
    );
};

export default TestPage;
